import React, { useState, useEffect } from 'react';
import { Col, Row, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faCheck, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

//Helpers
import { downloadBase64File, downloadZip } from '../../../../helpers/downloadFile';
import { formatarValorMonetario } from '../../../../helpers/formats';
import { showMessage } from '../../../../helpers/message';

//Componentes
import TabelaListagemFichas from '../../../../components/TabelaListagemFichas/TabelaListagemFichas';

//Context
import { useAuth } from '../../../../context/auth';

function AcoesRealizadas({ acoes = [], showDivs, infracao, impressaoPDFDividaAtiva }) {
    //Estado de controle de exibição dos valores dos cards
    const [showContent, setShowContent] = useState({});

    const { setLoading, session } = useAuth();

    const onClickTimeLine = (index) => {
        setShowContent({
            ...showContent,
            [index]: !showContent[index]
        })
    }

    //Cabeçalhos da lista de consulta infração
    const headersVotocao = [
        { value: "Usuário", objectValue: "usuario", align: "left" },
        { value: "Voto", objectValue: "voto", align: "left" },
        { value: "Data/Hora", objectValue: "dataHora", align: "left", formatDate: true },
        { value: "Observação", objectValue: "observacoes", align: "left" },
    ];

    useEffect(() => {
        if (acoes && acoes.length > 0) {
            setLoading(true);
            const _showContent = {};
            acoes.map((value, index) => {
                _showContent[index] = showDivs;
            })
            setShowContent(_showContent);
            setLoading(false);
        }
    }, [showDivs]);

    // Pré-computa o índice de cada boleto no array de ações, usando fiscalizacaoInfracaoAcao_Id.
    // Boletos gerados fora do roteiro de ações (ex: emitidos via Dívida Ativa) não têm ação
    // vinculada - localiza a etapa pela ação mais recente anterior à emissão do boleto.
    const boletosIndexados = (infracao?.boletos ?? []).map(boleto => {
        let acaoIndex = acoes.findIndex(a => a.id === boleto.fiscalizacaoInfracaoAcao_Id);
        if (acaoIndex === -1) {
            for (let i = acoes.length - 1; i >= 0; i--) {
                if (acoes[i]?.dataHora && moment(acoes[i].dataHora).isSameOrBefore(boleto.dataEmissao)) {
                    acaoIndex = i;
                    break;
                }
            }
            // Boleto emitido antes de qualquer ação datada (dado legado): mantém visível
            // desde a primeira ação em vez de descartar.
            if (acaoIndex === -1 && acoes.length > 0) acaoIndex = 0;
        }
        return { ...boleto, acaoIndex };
    });

    const statusNaoVigente = ["Vencido", "Cancelado"];

    const abrirBoleto = (boleto) => {
        if (!boleto?.arquivo) {
            showMessage("Atenção", "O arquivo deste boleto não está disponível. Solicite a emissão de um novo boleto.", "warning", null);
            return;
        }

        downloadBase64File(boleto.arquivo, "boletoFISCSP");
    }

    // Boletos relevantes para o histórico: o primeiro boleto emitido (mantido
    // mesmo se vencido) e, se houver, o último boleto liquidado (atualizado após pagamento).
    const boletosOrdenados = [...boletosIndexados]
        .filter(b => b.acaoIndex !== -1)
        .sort((a, b) => a.acaoIndex - b.acaoIndex);
    const primeiroBoleto = boletosOrdenados[0];
    const ultimoLiquidado = [...boletosOrdenados].reverse().find(b => b.status === "Liquidado");
    // CE-3680: o boleto atualizado (ainda vigente) precisa ficar visível para o infrator,
    // que nessa etapa não pode emitir um novo mas deve conseguir abrir o que foi emitido.
    const ultimoVigente = [...boletosOrdenados].reverse().find(b => !statusNaoVigente.includes(b.status) && b.status !== "Liquidado");
    const boletosRelevantes = [primeiroBoleto, ultimoLiquidado, ultimoVigente]
        .filter(Boolean)
        .filter((b, index, arr) => arr.findIndex(x => x.id === b.id) === index);

    return <>
        {acoes?.map((acao, key) => (
            <div key={key} style={{ position: "relative" }} className='contentGroup mt-4 shadowFicha rounded-3'>
                <div className='text-white pointHistory d-lg-flex d-md-none noPrint'>
                    <FontAwesomeIcon size='xs' icon={faCheck} />
                </div>
                <h5 role='button' onClick={() => onClickTimeLine(key)} className={`m-0 p-2 titleFicha ${showContent[key] || !!impressaoPDFDividaAtiva ? "mb-2" : "close"} d-flex justify-content-between align-items-center`} >
                    <span>
                        {acao.situacaoInfracao} - <span style={{ fontSize: "12pt", color: "#999" }}>{acao?.dataHora ? moment(acao?.dataHora).format("DD/MM/YYYY HH:mm") : ""}</span>
                    </span>
                    <span className='noPrint'>
                        <FontAwesomeIcon icon={showContent[key] || !!impressaoPDFDividaAtiva ? faAngleUp : faAngleDown} />
                    </span>
                </h5>
                <div className={`cardContainer ${showContent[key] || !!impressaoPDFDividaAtiva ? "" : "close"}`}>
                    <Row className='px-3 py-0'>
                        {session && !!acao?.acaoVotacoes?.length == 0 &&
                            <Col md="12" lg="6" className='mb-1'>
                                <span className="fw-bold">Responsável: </span> {acao?.usuario_Nome}
                            </Col>
                        }
                        {acao?.numeroProcessoInterno &&
                            <Col md="12" lg="6" className='mb-1'>
                                <span className="fw-bold">Número do processo interno: </span> {acao?.numeroProcessoInterno}
                            </Col>
                        }
                        {!!acao?.observacoes &&
                            <Col md="12" lg="12" className='mb-1'>
                                <span className="fw-bold">Observaçoes: </span> {acao.observacoes}
                            </Col>
                        }
                    </Row>
                    {acao?.acaoVotacoes?.length > 0 &&
                        <Row className='px-3 py-0'>
                            <TabelaListagemFichas
                                options={{ print: false, search: true, pagination: true }}
                                headers={headersVotocao}
                                items={acao.acaoVotacoes}
                            />
                        </Row>
                    }
                    {(() => {
                        const boletosVisiveis = boletosRelevantes.filter(boleto => {
                            // Oculta apenas boletos cancelados para sessão pública
                            if (session == null && boleto.status === "Cancelado")
                                return false;

                            // Boleto sem ação correspondente na timeline (ex.: gerado em etapa não exibida
                            // ao infrator) é apresentado na última ação, para não sumir da ficha
                            if (boleto.acaoIndex === -1) return key === acoes.length - 1;

                            // Exibe da etapa de emissão em diante (vigentes e vencidos)
                            return key >= boleto.acaoIndex;
                        });

                        if (boletosVisiveis.length === 0) return null;

                        return (
                            <>
                                <Row className='px-3 py-0'>
                                    <Col md="12" lg="12" className='mb-1'>
                                        <h5 className="fw-bold m-0">Boleto{boletosVisiveis.length > 1 ? "s" : ""}</h5>
                                    </Col>
                                </Row>
                                {boletosVisiveis.map((value, index) => (
                                    <Row className='px-3' key={index}>
                                        <Col md="12" lg="6" className='mb-2'>
                                            <span className="fw-bold">Valor: </span> {formatarValorMonetario(value?.valor)}
                                        </Col>
                                        <Col md="12" lg="6" className='mb-2'>
                                            <span className="fw-bold">Status: </span> {value?.status}
                                        </Col>
                                        <Col md="12" lg="6" className='mb-2'>
                                            <span className="fw-bold">Data de Criação: </span> {moment(value?.dataEmissao).format("DD/MM/YYYY")}
                                        </Col>
                                        <Col md="12" lg="6" className='mb-2'>
                                            <span className="fw-bold">Data de Vencimento: </span> {moment(value?.dataVencimento).format("DD/MM/YYYY")}
                                        </Col>
                                        {!!value?.valorJuros &&
                                            <Col md="12" lg="6" className='mb-2'>
                                                <span className="fw-bold">Valor de Juros: </span> {formatarValorMonetario(value.valorJuros)}
                                            </Col>
                                        }
                                        {value?.status === "Liquidado" && value?.dataPagamento &&
                                            <Col md="12" lg="6" className='mb-2'>
                                                <span className="fw-bold">Data de Pagamento: </span> {moment(value.dataPagamento).format("DD/MM/YYYY")}
                                            </Col>
                                        }
                                        {value?.status === "Liquidado" && !!value?.valorPago &&
                                            <Col md="12" lg="6" className='mb-2'>
                                                <span className="fw-bold">Valor Pago: </span> {formatarValorMonetario(value.valorPago)}
                                            </Col>
                                        }
                                        <Col md="12" lg="4" className='mb-2'>
                                            <Button
                                                outline
                                                color={statusNaoVigente.includes(value.status) ? "danger" : "success"}
                                                onClick={() => abrirBoleto(value)}
                                            >
                                                <FontAwesomeIcon icon={faFileDownload} />
                                                <span className="ms-2">Boleto {value.status}</span>
                                            </Button>
                                        </Col>
                                    </Row>
                                ))}
                            </>
                        );
                    })()}

                    {acao?.documentos.length > 0 ?
                        <Row className='px-3 py-0'>
                            <Col md="12" lg="12" className='mb-1' >
                                <h5 className="fw-bold m-0" >Documentos </h5>
                            </Col>
                        </Row> : ""
                    }

                    {acao?.documentos?.map((d, ke3) => (
                        <Row className='px-3 py-1 ' key={ke3}>
                            <div className='d-flex align-items-center justify-content-start flex-wrap gap-3 mb-2'>
                                <Button
                                    outline
                                    color={"secondary"}
                                    onClick={() => {
                                        const extensao = d?.arquivo?.split('.').pop()?.toLowerCase();
                                        if (extensao === "zip")
                                            downloadZip(d.base64, d.linkArquivo)
                                        else
                                            downloadBase64File(d.base64, d.identificacaoDocumento);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFileDownload} />
                                    <span className="ms-2">{d.identificacaoDocumento}</span>
                                </Button>
                            </div>
                        </Row>
                    ))}

                    <Row className='px-3 py-0'>
                        {acao?.formulario.length > 0 ?
                            <Col md="12" lg="12" className='mb-2'>
                                <h5 className="fw-bold m-0" >Formulário </h5>
                            </Col> : ""
                        }
                        {acao?.formulario?.map((f, key2) => (
                            <Col md="12" lg="12" className='mb-2' key={key2}>
                                <span className="fw-bold">{f.questao}: </span> {f?.resposta}
                            </Col>
                        ))}
                    </Row>
                    <Row className='px-3 py-0'>
                        {!!acao?.acaoIdentificacao &&
                            <Col md="12" lg="12" className='mb-1'>
                                <span className="fw-bold">Resposta: </span> {acao?.acaoIdentificacao}
                            </Col>
                        }
                    </Row>
                </div>
            </div>
        ))}
    </>;
}

export default AcoesRealizadas;